module.exports = __webpack_public_path__ + "static/media/mindfulness-for-sleep-large@2x.3fb75043.png";